import type { AreaSport } from "@/lib/planner/graph-types";

export function PlannerLoadingState({ sport }: { sport: AreaSport }) {
  const activity = sport === "mtb" ? "ride" : "day";

  return (
    <div
      role="status"
      aria-live="polite"
      aria-busy="true"
      className="rounded-[16px] border border-gold/25 bg-warm-bg p-6 text-center"
    >
      <p className="font-serif text-[21px] font-bold text-navy">
        Building your best {activity}
      </p>
      <div
        role="progressbar"
        aria-label={`Building your best ${activity}`}
        aria-valuetext="Comparing the best route options"
        className="mx-auto mt-4 h-1.5 max-w-[280px] overflow-hidden rounded-full bg-navy/10"
      >
        <div className="h-full w-full animate-pulse bg-gradient-to-r from-gold/40 via-gold to-gold/40 motion-reduce:animate-none" />
      </div>
      <p className="mx-auto mt-4 max-w-[330px] text-[13px] leading-relaxed text-text-muted">
        Comparing today&apos;s conditions, mountain connections and the best way home.
      </p>
      <p className="mt-1 text-[12px] leading-relaxed text-text-muted">
        Bigger mountain networks can take a few seconds.
      </p>
    </div>
  );
}
